/* eslint-disable no-restricted-imports */
import React, { useRef } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Text,
} from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';

// Confirmation dialog in the app's standard destructive-action style
// (same look as the Goals / Models delete dialogs: centered, bold
// marketingPage header, ghost Cancel, solid red confirm).
type ConfirmDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  headerText: string;
  bodyText: React.ReactNode;
  confirmText: string;
  isLoading?: boolean;
};

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  headerText,
  bodyText,
  confirmText,
  isLoading = false,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent bg="surface.panel">
          <AlertDialogHeader
            fontFamily="marketingPage"
            fontWeight="bold"
            fontSize="lg"
            color="content.title">
            {headerText}
          </AlertDialogHeader>
          <AlertDialogBody>
            {typeof bodyText === 'string' ? <Text>{bodyText}</Text> : bodyText}
          </AlertDialogBody>
          <AlertDialogFooter gap={3}>
            <Button
              ref={cancelRef}
              onClick={onClose}
              buttonName="cancel-confirm-dialog"
              variant="ghost">
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              isLoading={isLoading}
              buttonName="confirm-dialog-action"
              sx={{
                bg: 'background.red.500',
                color: 'white',
                _hover: { bg: 'red.600' },
              }}>
              {confirmText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
